import { LocaleEnum } from '../enums';

import { Dictionary, YearlySummaryMessages } from '../models';

const YEARLY_SUMMARY_MESSAGES_EN: YearlySummaryMessages = {
  title: 'Yearly Summary',
  comparedLastYear: '*Compared with the last year',
  branding: 'LONDON | NEW YORK | ASTURIAS | GALICIA',
  topProducts: {
    actions: 'Actions'
  },
  actions: {
    close: 'Close',
    noThanks: 'No, thanks',
    previous: 'Previous',
    next: 'Next',
    download: 'Download Yearly Summary'
  }
};

const YEARLY_SUMMARY_MESSAGES_ES: YearlySummaryMessages = {
  title: 'Yearly Summary',
  comparedLastYear: '*Compared with the last year',
  branding: 'LONDON | NEW YORK | ASTURIAS | GALICIA',
  topProducts: {
    actions: 'Actions'
  },
  actions: {
    close: 'Close',
    noThanks: 'No, thanks',
    previous: 'Previous',
    next: 'Next',
    download: 'Download Yearly Summary'
  }
};

export const YEARLY_SUMMARY_MESSAGES: Dictionary<{ yearlySummary: YearlySummaryMessages }> = {
  [LocaleEnum.ENGLISH]: {
    yearlySummary: YEARLY_SUMMARY_MESSAGES_EN
  },
  [LocaleEnum.SPANISH]: {
    yearlySummary: YEARLY_SUMMARY_MESSAGES_ES
  }
};
